<template>
  <div id="callCenter">
    <div class="udeskBtn" id="udeskBtn" @click="openUdesk">
       <img class="footer-fun-img" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/footer-call1.png">
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    openUdesk () {
      if (!window.ud) {
        (function (a, h, c, b, f, g) { a['UdeskApiObject'] = f; a[f] = a[f] || function () { (a[f].d = a[f].d || []).push(arguments) }; g = h.createElement(c); g.async = 1; g.charset = 'utf-8'; g.src = b; c = h.getElementsByTagName(c)[0]; c.parentNode.insertBefore(g, c) })(window, document, 'script', 'https://assets-cli.s2.udesk.cn/im_client/js/udeskApi.js', 'ud')
        ud({
          'code': '183fgck5',
          'link': 'https://haoweilai.s2.udesk.cn/im_client/?web_plugin_id=28225',
          'targetSelector': '#udeskBtn'
        })
        this.listenUdeskStatus()
      }
    },
    listenUdeskStatus () {
      const timer = setInterval(() => {
        if (window.udesk_jsonp0 && window.udesk_jsonp0 && window.udesk_jsonp0) {
          clearInterval(timer)
          document.getElementById('udeskBtn').click()
        }
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
  .udeskBtn{
    cursor: pointer;
    .footer-fun-img{
      width: 135px;
      height: 40px;
      margin-right: 61px;
    }
  }
</style>
